module.exports = __webpack_public_path__ + "img/141.410235e7.jpg";